import { faListCheck } from '@fortawesome/pro-solid-svg-icons'
import type { ReactElement } from 'react'
import { NoResult } from '~/components/Global/Elements/NoResult/NoResult'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import { AsideAction } from '~/components/Scopes/Actions/AsideAction'
import { useCloseAction } from '~/components/Scopes/Actions/hooks/useCloseAction'
import { useTask } from '../../queries/task'
import { TaskAsideContent } from './TaskAsideContent'

type TaskAsideProps = {
  taskId: number
}

export const TaskAside = ({ taskId }: TaskAsideProps): ReactElement => {
  const { data: task, isLoading, isError } = useTask(taskId)
  const closeAction = useCloseAction()

  if (isError || (!isLoading && !task)) {
    return (
      <AsideAction title="Tâche">
        <NoResult
          isError
          icon={faListCheck}
          message="Impossible de charger cette tâche"
          onDismiss={() => closeAction(true)}
          dismissLabel="Fermer"
        />
      </AsideAction>
    )
  }

  if (isLoading || !task) {
    return (
      <AsideAction title="Tâche">
        <Shimmer width="100%" height={40} />
        <Shimmer width="100%" height={120} />
      </AsideAction>
    )
  }

  // The aside element is reused from one task to the next: remount the content so its state (status tabs, edit panel) starts from the new task
  return <TaskAsideContent key={task.id} task={task} />
}
